<template>
    <DxLoadPanel :position="position" class="lgi-loadpanel"
                 v-model:visible="loadingVisible"
                 :show-indicator="true"
                 :copy-root-classes-to-wrapper="true"
                 :show-pane="true"
                 :shading="true"
                 :width="150"
                 message="Please wait ..."
                 shading-color="rgba(0,0,0,0.4)" />
    <div class="lgi">
        <form action="post"
              @submit="onFormSubmit($event)">
            <div class="resp-form">
                <div class="lgi-header">
                    <div class="pq4-logo">
                    </div>
                    <div class="lgi-welcome">
                        Login
                    </div>
                    <!--<div class="lgi-welcome-text">
                        Log in to the AI Grid Portal
                    </div>-->
                </div>
                <div class="field">
                    <div class="dx-email-value">
                        <DxTextBox v-model:value="userName"
                                   :show-clear-button="false"
                                   mode="name"
                                   label="Email"
                                   label-mode="static"
                                   placeholder="Enter email">
                        </DxTextBox>
                    </div>
                </div>
                <div class="field">
                    <div class="dx-pass-value">
                        <DxTextBox v-model:value="password"
                                   :show-clear-button="false"
                                   label="Password"
                                   label-mode="static"
                                   mode="password"
                                   placeholder="Enter password">
                        </DxTextBox>
                    </div>
                    <div class="dx-pass-reset">
                        <div class="lgi-reset-btn pq4-link" @click="resetPassword()">Forgot Password?</div>
                    </div>
                </div>
                <div class="lgi-err-msg" v-if="hasMessage">
                    {{ errorMessage }}
                </div>
                <div class="lgi-btns">
                    <DxButton class="logBtn"
                              text="Login"
                              type="success"
                              :use-submit-behavior="true" />

                </div>
                <!--<div class="lgi-footer">
                    <div class="lgi-footer-text">
                        No AI Grid Account yet?
                    </div>
                    <div class="lgi-sign-btn pq4-link" @click="register()">Register now</div>
                </div>-->
            </div>
        </form>
    </div>
    <FooterSmall></FooterSmall>
</template>
<script>
    import { DxButton } from 'devextreme-vue/button';
    import DxLoadPanel from 'devextreme-vue/load-panel';
    import DxTextBox from 'devextreme-vue/text-box';
    import FooterSmall from './widgets/FooterSmall.vue';
    import axios from 'axios'

    const baseUri = "Public/WebApi.asmx/api/user";
    const stateEnum = {
        NotAuthenticated: 0,
        Authenticated: 1,
        Error: 2,
        Redirect: 3,
        Locked: 4,
        EmailNotConfirmed: 5,
        TemporaryLocked: 6,
        Denied: 7
    }
    export default {

        name: 'LoginPage',
        components: {
            DxButton,
            DxTextBox,
            DxLoadPanel,
            FooterSmall
        },
        data() {
            return {
                loadingVisible: false,
                userName: "",
                password: "",
                errorMessage: "",
            }
        },
        mounted() {
        },
        created: function () {


        },
        computed: {
            hasMessage() {
                return this.errorMessage && this.errorMessage.length > 0
            }
        },
        methods: {
            onFormSubmit(e) {
                this.logIn();
                e.preventDefault();
            },
            toLandingPage() {
                window.location.href = "./landingPage.aspx"
            },
            register() {
                window.location.href = "Public/RegisterAsParticipant.aspx"
            },
            resetPassword() {
                window.location.href = "Public/ResetPassword.aspx"
            },
            logIn() {
                this.loadingVisible = true
                var formData = new FormData()
                formData.append("userName", this.userName)
                formData.append("password", this.password)
                axios
                    .post(baseUri + '/Login', formData)
                    .then(res => {
                        if (res.data.Success == true) {
                            switch (res.data.State) {
                                case stateEnum.Authenticated:
                                    window.location.href = "Start.aspx" + window.location.search
                                    return;
                            }
                        }
                        else {
                            this.loadingVisible = false
                            this.password = ""
                            switch (res.data.State) {
                                case stateEnum.Authenticated:
                                    window.location.href = "Start.aspx" + window.location.search
                                    return
                                case stateEnum.NotAuthenticated:
                                    this.errorMessage = "Wrong username or password"
                                    return
                                case stateEnum.Denied:
                                    this.errorMessage = "Access denied"
                                    return
                                case stateEnum.Locked:
                                    this.errorMessage = "Account locked"
                                    return
                                case stateEnum.EmailNotConfirmed:
                                    this.errorMessage = "Your email address is not confirmed! We have sent an email to "
                                        + this.userName + " with a confirmation link. Use this link to confirm your email address."
                                    return
                                default:
                                    this.errorMessage = "Server Error"
                                    return

                            }
                        }
                    })
            }
        }
    }
</script>
<style>
    .lgi .field {
        display: flex;
        flex-direction: column;
        padding: 10px 0px 10px 0px;
    }

    .lgi .lgi-err-msg {
        color: red;
        font-size: 12px;
        font-weight: bold;
    }

    .lgi .lgi-btns {
        display: flex;
        flex-direction: column;
        padding: 0 0px 10px 0px;
    }

    .lgi div#summary {
        margin-bottom: 10px;
    }


    .lgi .lgi-btns {
        margin-top: 10px;
        text-align: center;
    }

    .lgi .dx-pass-value, .lgi .dx-email-value {
    }


    .lgi-loadpanel .dx-loadpanel-indicator.dx-loadindicator.dx-widget {
        margin: auto;
        display: block;
    }

    .login_aspx #pq4Logo {
        display: none;
    }

    .lgi-btns .dx-button-content {
        background: #304897;
    }

    .lgi-welcome-text {
        font-size: 15px;
        text-align: center;
        margin-bottom: 5px;
    }

    .lgi-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .lgi-footer-text {
        font-size: 12px;
    }

    .lgi .lgi-sign-btn {
        color: #f65923;
        font-size: 12px;
        font-weight: bold;
    }

    .dx-texteditor-label .dx-label {
        color: #b3b5b7
    }

    .lgi .lgi-reset-btn.pq4-link {
        font-size: 11px;
        text-align: right;
        color: #7d7c84;
    }
</style>